/* ============
 * State of user module
 * ============
 *
 * The initial state of the suggestion module.
 */

export default {
  jwt: null,
  exp: null,
  // SESIÓN DE CR AUTH (tokens y vencimientos absolutos, ver interfaces/authMappers.toSession)
  session: null,
  // ONLY FOR LOGIN / REGISTER NEW FLOW
  names: null,
  coUs: null,
  // ALL DATA USER
  user: null,
  // INITIAL VALUES FOR LOGIN / REGISTER NEW FLOW
  initialValues: null,
  info: null,
  historyPayments: null,
  polizas: null,
  polizasVidaVehicular: null,
  electronicDocs: null,
  haveLoanRequested: null,
  niubizSessionKey: null,
  ip: '192.168.0.1',
  search: null,
  functions: {},
  extra: {},
  prestamosVidaDisponibilidad: null
}



// WEBPACK FOOTER //
// ./src/store/modules/user/state.js